var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.858,
    height: 18.124,
    viewBox: "0 0 15.858 18.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4e4e4e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.929,18.124a2.265,2.265,0,0,0,2.264-2.265H5.665A2.265,2.265,0,0,0,7.929,18.124Zm7.624-5.3c-.684-.735-1.964-1.84-1.964-5.462A5.59,5.59,0,0,0,9.061,1.87V1.133a1.132,1.132,0,1,0-2.264,0V1.87A5.59,5.59,0,0,0,2.268,7.363c0,3.621-1.28,4.727-1.964,5.462a1.106,1.106,0,0,0-.3.768,1.134,1.134,0,0,0,1.136,1.133H14.722a1.133,1.133,0,0,0,1.136-1.133A1.105,1.105,0,0,0,15.553,12.824Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeBell);
export default __webpack_public_path__ + "static/media/Icon awesome-bell.4a9ea85eb3c3f446edc1b30c5909a156.svg";
export { ForwardRef as ReactComponent };